<template>
  <div>
    <table class="table">
      <thead>
        <tr>
          <th v-for="column in columns" :key="column.key" :width="column.width">
            <slot :name="`header-${column.key}`" :column="column">
              <bg-text size="title-5"> {{ column.label }} </bg-text>
            </slot>
          </th>
        </tr>
      </thead>

      <tbody v-if="loading" data-testid="table-loader">
        <tr v-for="i in 3" :key="`skeleton-row-${i}`">
          <td v-for="i in columns.length" :key="`skeleton-cell-${i}`">
            <bg-skeleton :height="20" width="100%" />
          </td>
        </tr>
      </tbody>

      <tbody v-else>
        <tr
          v-for="(row, index) in rows"
          :key="`row-${index}`"
          data-testid="table-row"
        >
          <td
            v-for="column in columns"
            :key="column.key"
            :data-testid="`table-column-${column.key}`"
          >
            <slot :name="`column-${column.key}`" :row="row" :index="index">
              <bg-text size="body-2">
                {{ row[column.key] || '-' }}
              </bg-text>
            </slot>
          </td>
        </tr>

        <tr v-if="rows.length == 0">
          <td :colspan="columns.length" class="bg-u-bg-neutral-50">
            <div class="table__empty-text">
              <slot name="empty-state">
                <bg-text size="body-2">Belum ada data</bg-text>
              </slot>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { BgText, BgSkeleton } from 'bangul-vue';

export default {
  components: {
    BgText,
    BgSkeleton,
  },

  props: {
    /**
     * Defines the columns in the table. Each column object includes:
     * - `key` (String): Unique identifier, used to access row data.
     * - `label` (String): Display name shown in the header.
     * - `width` (String or Number, optional): Column width (e.g. 200).
     *
     * Example:
     * columns: [
     *   { key: 'name', label: 'Name' },
     *   { key: 'age', label: 'Age', width: 200 }
     * ]
     */
    columns: {
      type: Array,
      required: true,
    },

    /**
     * Array of row objects representing table data.
     * Each row should include keys matching `columns.key`.
     *
     * Example:
     * rows: [{ name: 'John Doe', age: 28 }]
     */
    rows: {
      type: Array,
      required: true,
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style src="./DataTable.scss" lang="scss" scoped></style>
